// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react'

import PropTypes from '@ttn-lw/lib/prop-types'

const ListItem = function(props) {
  const { className, component: Component, children, ...rest } = props

  return (
    <Component className={className} {...rest}>
      {children}
    </Component>
  )
}

ListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.string,
}

ListItem.defaultProps = {
  children: undefined,
  className: undefined,
  component: 'li',
}

export default ListItem
